<template>
  <transaction-row-base :actualAmount="actualAmount"
                        :transactionDate="transactionDate"
                        :transactionDescription="transactionDescription"
                        :isSelected="isSelected"
                        :out-of-date="outOfDate"
                        :can-edit-envelope="canEditCategory"
                        :customer-comment="customerComment"
  />
</template>

<script>
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';
import TransactionRowBase from './TransactionRowBase';

export default {
  name: 'TransactionRow',
  mixins: [TransactionDisplayUtils],
  components: {
    TransactionRowBase,
  },
  props: [
    'transaction',
    'canEditCategory',
    'categoryId',
    'isSelected',
    'outOfDate',
  ],
  computed: {
    isTransactionEditable() {
      return this.canEditCategory;
    },
    transactionDate() {
      return this.transaction.transactionDate;
    },
    customerComment() {
      return this.transaction.customerComment;
    },
    actualAmount() {
      return +this.getTransactionAmountWithoutFraction(this.transaction);
    },
    businessName() {
      return this.transaction.businessName;
    },
    transactionPayment() {
      return this.getTransactionPayment(this.transaction);
    },
    transactionAccount() {
      return this.getTransactionAccount(this.transaction);
    },
    transactionDescription() {
      return `${this.businessName} ${this.transactionPayment} ${this.transactionAccount}`;
    },
  },
  methods: {
    getTransactionPayment(transaction) {
      return transaction.paymentNumber > 0 ? `- תשלום${transaction.paymentNumber}/${transaction.totalNumberOfPayments}` : '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
</style>
